import React from 'react';

import { VisitorsLayoutV2Wrapper } from './visitors-layout-v2.styles';

interface VisitorsLayoutV2Props {
  children: React.ReactNode;
}

/**
 * Layout component for V2 visitor management UI
 * Placeholder implementation - will be enhanced later
 */
export const VisitorsLayoutV2 = ({ children }: VisitorsLayoutV2Props): JSX.Element => (
  <VisitorsLayoutV2Wrapper>{children}</VisitorsLayoutV2Wrapper>
);
